import React from "react";
import { Heading } from "@chakra-ui/core";

const SectionTitle = (props) => <Heading as="h3" size="lg" mb={4} {...props} />;

export default SectionTitle;
